import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  token: string;
  jsonKey: string;
}

const initialState: AuthState = {
  token: '',
  jsonKey: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthToken: (state: AuthState, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setJSONKey: (state: AuthState, action: PayloadAction<string>) => {
      state.jsonKey = action.payload;
    },
  },
});

const { actions } = authSlice;

export const authSliceActions = {
  ...actions,
};

export default authSlice;
